// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"9cd61000a565e220","468":"da7e0b74e3d364ef"}[chunkId] + ".css";
};